export enum Context {
  AddPeopleToContent,
  AddPeopleToGroups,
  AddPackToUsersOrGroups,
  AddPacksToUserOrGroup,
}
